import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _this;

import infoList from "@/mixins/infoList";
export default {
  name: "OrderStatusTag",
  props: ["orderStatus", "orderStatusName", "refundStatus", "refundStatusName"],
  mixins: [infoList],
  data: function data() {
    return {};
  },
  computed: {},
  methods: {},
  filters: {},
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};